import { Component, Input } from '@angular/core';
import { PolicyValidityStatusCodeEnum, PurchasedProductInterface } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-list-notice',
    templateUrl: 'insurance-list-notice.component.html',
    styleUrls: [ 'insurance-list-notice.component.scss' ],
})
export class InsuranceListNoticeComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    public validityStatusCodeEnum = PolicyValidityStatusCodeEnum;
}
